export const environment = {
    baseUrl: 'http://grilaft-prod.test',
    siteName: "GeovyPe",
    version: "1.0.1",
    appID: "geovy_pe",
    clientId: "grilaft-client-api-rest",
    secretKey: "J&C_G30vYP3_",
    secretKeyApp: "-0-P.E3G30vy..-x",
    nameAccessToken: "access_token",
    nameRefreshToken: "refresh_token",
    serverUrl:'https://geovype.com',
    socketUrl: 'https://nomadeappservices.org',
    constants: {
        mailinfo: "localinfo",
        uid: "localuinfo",
    }
};
